(() => {
  // FoxKit owns the menu content; this adds keyboard access and Escape dismissal.
  document.querySelectorAll('foxkit-menu.emery-navigation').forEach((menu) => {
    const deferMobileImages = () => {
      if (!window.matchMedia('(max-width: 1023px)').matches) return;

      menu.querySelectorAll('.f-menu__banner img').forEach((image) => {
        image.loading = 'lazy';
        image.fetchPriority = 'low';
      });
    };

    const initialise = () => {
      deferMobileImages();
      const items = [...menu.querySelectorAll(':scope > .f-menu__item-parent')];
      if (!items.length) return false;

      menu.setAttribute('role', 'navigation');
      menu.setAttribute('aria-label', window.MinimogStrings.mainNavigation);
      let openItem;

      const close = () => {
        if (!openItem) return;
        openItem.removeAttribute('data-emery-open');
        openItem.querySelector(':scope > a').setAttribute('aria-expanded', 'false');
        openItem = null;
      };

      const open = (item) => {
        close();
        openItem = item;
        item.setAttribute('data-emery-open', '');
        item.querySelector(':scope > a').setAttribute('aria-expanded', 'true');
      };

      items.forEach((item) => {
        item.removeAttribute('role');
        const link = item.querySelector(':scope > a');
        const panel = item.querySelector(':scope > .f-menu__submenu');
        if (!link || !panel) return;

        panel.id = `${item.id}-panel`;
        link.setAttribute('aria-controls', panel.id);
        link.setAttribute('aria-expanded', 'false');
        item.addEventListener('pointerenter', () => open(item));
        item.addEventListener('pointerleave', () => {
          if (!item.contains(document.activeElement)) close();
        });
        item.addEventListener('focusin', () => open(item));
        item.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) close();
        });
        item.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            link.focus();
            close();
          } else if (event.target === link && ['ArrowDown', ' '].includes(event.key)) {
            event.preventDefault();
            open(item);
            [...panel.querySelectorAll('a[href]')]
              .find((target) => target.getClientRects().length)?.focus();
          }
        });
      });

      menu.setAttribute('data-emery-ready', '');
      return true;
    };

    if (initialise()) return;
    const observer = new MutationObserver(() => {
      if (initialise()) observer.disconnect();
    });
    observer.observe(menu, { childList: true });
  });
})();
